
(function(){
  function initCountdown(root){
    var box=root.querySelector('[data-countdown]'); if(!box) return;
    var target = new Date(root.getAttribute('data-countdown-date') || '2026-12-31T00:00:00').getTime();
    var days=box.querySelector('[data-days]'), hours=box.querySelector('[data-hours]'), minutes=box.querySelector('[data-minutes]'), seconds=box.querySelector('[data-seconds]');
    function pad(n){ return String(Math.max(0,n)).padStart(2,'0'); }
    function tick(){
      var diff=Math.max(0,target-Date.now());
      var d=Math.floor(diff/86400000); diff-=d*86400000;
      var h=Math.floor(diff/3600000); diff-=h*3600000;
      var m=Math.floor(diff/60000); diff-=m*60000;
      var s=Math.floor(diff/1000);
      if(days) days.textContent=pad(d); if(hours) hours.textContent=pad(h); if(minutes) minutes.textContent=pad(m); if(seconds) seconds.textContent=pad(s);
    }
    tick(); setInterval(tick,1000);
  }
  function initWaitlist(root){
    var form=root.querySelector('[data-valse-waitlist-form]'); var success=root.querySelector('[data-waitlist-success]'); var error=root.querySelector('[data-waitlist-error]');
    if(!form || !success) return;
    form.addEventListener('submit', function(e){
      var email=form.querySelector('input[type="email"]');
      if(!email || !email.checkValidity()){ e.preventDefault(); if(error) error.hidden=false; return; }
      if(error) error.hidden=true;
      // Let Shopify receive the customer/newsletter form in the background when possible, but show the launch code instantly.
      e.preventDefault();
      var data=new FormData(form);
      fetch(form.action, {method:'POST', body:data, credentials:'same-origin'}).catch(function(){});
      form.hidden=true; success.hidden=false;
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ document.querySelectorAll('[data-password-launch]').forEach(function(root){ initCountdown(root); initWaitlist(root); }); });
})();
